// src/pages/History/EarlyModern/AztecIncaEmpires.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Early_Modern_Period_-_Aztec_and_Inca_Empires.png';

function HistoryPageAztecIncaEmpires() {
  return (
    <TopicPage
      topicKey="Aztec and Inca Empires"
      title="History: Aztec and Inca Empires"
      backgroundImage={bg}
      startRoute="/History-Aztec-Inca-Empires-Go"
      scrollLabels={[
        "Aztec Society and Religion",
        "Inca Roads and Administration",
        "European Conquest and Collapse",
      ]}
      backRoute="/history-early-modern"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAztecIncaEmpires;
